module.exports = __webpack_public_path__ + "static/media/CHARGING_TERMINAL-0.cf98613f.png";